import './App.scss';
import MainTemplate from './Components/MainComponent/Template/MainTemplate';
import { Route, Routes, Navigate } from "react-router-dom";
import Home from './Views/Home/Home';
import AboutUs from './Views/AboutUs/AboutUs';
import Smartbip from './Views/Smartbip/Smartbip';
import Ecommerce from './Views/Smartbip/Ecommerce/Ecommerce';
import SelfScanning from './Views/Smartbip/SelfScanning/SelfScanning';
import Inventory from './Views/Smartbip/Inventory/Inventory';
import Fidelity from './Views/Smartbip/Fidelity/Fidelity';
import Faq from './Views/FAQ/Faq';
import Contact from './Views/Contact/Contact';
import ThankYou from './Views/ThankYou/ThankYou';
import Cookies from './Views/Privacy/Cookies';
import Policy from './Views/Privacy/Policy';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const helmetContext = {};
  return (
    <HelmetProvider context={helmetContext}>
      <MainTemplate>
        <Routes>
          <Route path="*" element={<Navigate to="home" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="policy" element={<Policy />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="faq" element={<Faq />} />
          <Route path="contact" element={<Contact />} />
          <Route path="thanks" element={<ThankYou />} />
          <Route path="smartbip" element={<Smartbip />} />
          <Route path="smartbip/ecommerce" element={<Ecommerce />} />
          <Route path="smartbip/selfscanning" element={<SelfScanning />} />
          <Route path="smartbip/inventory" element={<Inventory />} />
          <Route path="smartbip/fidelity" element={<Fidelity />} />
        </Routes>
      </MainTemplate>
    </HelmetProvider>
  );
}

export default App;
